import { useTranslation } from "react-i18next";

import getCalendarBusinessHours from "../../../utils/getCalendarBusinessHours";

export default function useCalendarReaderResources({ readers }) {
	const { t } = useTranslation();

	const resources = readers.map((reader) => ({
		id: reader.id,
		title: reader.firstName,
		group: Object.values(reader.vendors || {})[0]?.city || t("unassigned", "Unassigned"),
		businessHours: getCalendarBusinessHours({ users: [reader] }),
		reader,
	}));

	return { resources, resourceColors: {} };
}
